import { CreateGround } from '@babylonjs/core/Meshes/Builders/groundBuilder';
import { ShadowOnlyMaterial } from '@babylonjs/materials/shadowOnly/shadowOnlyMaterial';

import * as ThreeUtilities from './threeutilities';

export default {
    methods: {
        /**
         * Create or update the ground plane.
         */
        applyGround() {
            if (!this.scene) {
                return;
            }

            if (this.ground) {
                return;
            }

            const worldSize = this.scene.getWorldExtends((mesh) => mesh.isVisible && mesh.isEnabled());

            const sizeX = worldSize.max.x - worldSize.min.x;
            const sizeZ = worldSize.max.z - worldSize.min.z;

            if (this.groundSizeX === sizeX && this.groundSizeZ === sizeZ) {
                return;
            }

            // Is it of reasonable size?
            if (Math.abs(sizeX) > 10000 || Math.abs(sizeZ) > 10000) {
                return;
            }

            // Unless the target has ground element or ground exclusions, retain the old stuff.
            const hasGround = Object.keys(this.view.custom).some((x) => x.startsWith('three-ground-'));

            const useView = hasGround ? this.view : this.firstView;

            this.groundSizeX = sizeX;
            this.groundSizeZ = sizeZ;

            const validated = [];

            for (let index = 1; ; index += 1) {
                if (useView && useView.custom[`three-ground-${index}-name`]) {
                    let size = Math.max(sizeX, sizeZ);

                    let scale = 2;

                    if (useView.custom[`three-ground-${index}-scale`]) {
                        scale = ThreeUtilities.toFloat(useView.custom[`three-ground-${index}-scale`]);
                    }

                    size *= scale;

                    const ground = CreateGround(`ground-${index}`, {
                        width: size,
                        height: size,
                    }, this.scene);

                    ground.renderingGroupId = 0;

                    this.updateGround(useView, ground, index);

                    validated.push(ground);
                } else {
                    break;
                }
            }

            if (!this.ground) {
                this.ground = [];
            }

            // Dispose old.
            [...this.ground].forEach((g) => {
                g.dispose(false, true);
            });

            // Track new.
            validated.forEach((g) => {
                this.ground.push(g);
            });
        },

        updateGround(useView, ground, index) {
            if (useView.custom[`three-ground-${index}-offset`]) {
                ground.position.z = ThreeUtilities.toFloat(useView.custom[`three-ground-${index}-offset`]);
            }

            if (useView.custom[`three-ground-${index}-shadow`]) {
                ground.receiveShadows = true;

                if (ground.material) {
                    ground.material.dispose();
                }

                ground.material = new ShadowOnlyMaterial('ground-material', this.scene);

                if (this.lights) {
                    const lightName = useView.custom[`three-ground-${index}-shadow`];

                    const light = Object.values(this.lights).find((x) => x.lightName === lightName);

                    if (light) {
                        ground.material.activeLight = light.light;
                    }
                }

                if (useView.custom[`three-ground-${index}-shadow-color`]) {
                    ground.material.shadowColor = ThreeUtilities.toColor3(useView.custom[`three-ground-${index}-shadow-color`]);
                }
            }
        },
    },
};
